/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import Navbar from "../components/TopNav";
import Footer from "../components/Footer";
import { Route, Switch, Redirect } from "react-router-dom";
import cross from "../images/landing/cross.svg";
import SideBox from "../components/marketPlace/sideBox";
import ThreeDView from "../components/marketPlace/threeDView";
import Score from "../components/marketPlace/Score";
import RenderData from "../components/marketPlace/RenderData";
import RentNft from "../components/marketPlace/RentNft";

const MarketPlace = ({ match, history, location }) => {
  const [overlay, setOverLay] = useState(true);
  const [type, setType] = useState("buy");

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    const day = days.toString().length === 1 ? 0 : "";
    const hour = hours.toString().length === 1 ? 0 : "";
    const min = minutes.toString().length === 1 ? 0 : "";
    const sec = seconds.toString().length === 1 ? 0 : "";
    return (
      <p className="time-para">
        <span>
          {day}
          {days}
        </span>{" "}
        :{" "}
        <span>
          {hour}
          {hours}
        </span>{" "}
        :{" "}
        <span>
          {min}
          {minutes}
        </span>{" "}
        :{" "}
        <span>
          {sec}
          {seconds}
        </span>
      </p>
    );
  };

  const rentRoute = () => {
    history.push(`/staking`);
  };

  const buyRoute = () => {
    if (location.pathname.includes("rent")) {
      const name = history.location.pathname.slice(19);
      history.push(`/market-place/assets/${name}`);
    }
  };
  const tDate = new Date(Date.UTC(2021, 9, 13, 18, 0, 0));
  const utcDate = tDate.toUTCString();
  return (
    <div className="row no-gutters market-place">
      <Navbar />
      <div className="col-12 main">

      {/* {size >= 769 && (
       <video className="web-vid" width="100%"  muted autoPlay loop>
       <source src={video1} type="video/mp4" />
     </video>
      )}
       {size <= 768 && (
        <video className="web-vid" width="100%"  muted autoPlay loop>
        <source src={mobile} type="video/mp4" />
      </video>
      )} */}
        
      </div>

      <div className="col-12 main">
        <div className="first-top">
          <div className="toggle-div">
            <button
              onClick={buyRoute}
              className={`${
                match.params.name !== "rent" ? "active-btn" : ""
              } inactive btn`}
            >
              BUY NFTS
            </button>
            <button
              onClick={rentRoute}
              className={`${
                match.params.name === "rent" ? "active-btn" : ""
              } inactive btn`}
            >
              RENT NFTS
            </button>
            {match.params.name !== "rent" && (
              <p className="detail-para">
                Introducing Monsters Clan NFT Marketplace, a dedicated space for
                everyone to buy their favorite Monsters Clan game NFTs such as
                Monsters, Island Plots, Potions, and many others.
              </p>
            )}
            {match.params.name === "rent" && (
              <p className="detail-para">
                Stay patient everyone, soon all of you will be able to avail the
                feature of Rent NFTs on Monsters Clan NFT Marketplace
              </p>
            )}
          </div>
          <Score overlay={overlay} />
        </div>
        <div className="row no-gutters">
          <SideBox />
          <div className="col-lg-8 col-sm-12">
            <Switch>
              <Route exact path="/market-place/assets">
                <Redirect to="/market-place/assets/monster" />
              </Route>
              <Route path="/market-place/assets/:name" component={RenderData} />
              <Route
                path="/market-place/asset/:name/:id"
                component={ThreeDView}
              />
            </Switch>

            {overlay && (
              <div
                className={`${
                  match.url === "/market-place/asset" ? "" : "increase-width"
                } bottom-div`}
              >
                <button onClick={() => setOverLay(false)} className="btn">
                  <img width="80%" src={cross} alt="" />
                </button>
                <div>
                  <h5>NFT SALE HAS BEEN CLOSED!</h5>
                  <p className="dics">
                    Thanks to Monsters Clan community for such a great response
                    in NFT sales. Stay tuned as we are coming with some exciting
                    and good news.
                  </p>
                </div>
                {/* <Countdown renderer={renderer}
              date={utcDate} 
              /> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MarketPlace;
